import type { ForumBase } from '../types/forum';
import { getForumGrowthPercent } from './forumGrowth';

export type RiskLevel = 'healthy' | 'watch' | 'declining' | 'critical';

export interface RiskInfo {
  level: RiskLevel;
  label: string;
  score: number;
}

export function computeForumRisk(forum: ForumBase): RiskInfo {
  let score = 0;
  if (!forum.is_active) {
    return { level: 'critical', label: 'Kapalı', score: 100 };
  }
  const memberGrowth = getForumGrowthPercent(forum, 'members');
  const postGrowth = getForumGrowthPercent(forum, 'posts');
  if (memberGrowth !== null && memberGrowth < -5) score += 35;
  if (postGrowth !== null && postGrowth < -5) score += 25;
  const updated = forum.updated_at || forum.created_at;
  if (updated) {
    const days = (Date.now() - new Date(updated).getTime()) / (86400000);
    if (days > 90) score += 40;
    else if (days > 30) score += 20;
  } else {
    score += 15;
  }
  if (forum.http_last_ok === false) score += 30;

  if (score >= 70) return { level: 'critical', label: 'Risk yüksek', score };
  if (score >= 45) return { level: 'declining', label: 'Düşüşte', score };
  if (score >= 25) return { level: 'watch', label: 'İzlenmeli', score };
  return { level: 'healthy', label: 'Sağlıklı', score };
}
